<template>
  <div class="nebIcon"
    :height="height"
    :width="width"
    :class="[ name ]"
  >
    <component :is="iconComponent"
      :height="height"
      :width="width"
      v-bind="options"
    />
  </div>
</template>

<script>
const icons = {
  search: () => import('./IconSearch'),
  info: () => import('./IconInfo'),
  x: () => import('./IconX'),
  caretDown: () => import('./IconCaretDown'),
  caretLeft: () => import('./IconCaretLeft'),
  caretRight: () => import('./IconCaretRight'),
  check: () => import('./IconCheck'),
  eye: () => import('./IconEye'),
  social: () => import('./IconSocial'),
  funnel: () => import('./IconFunnel'),
  pieChart: () => import('./IconPieChart'),
  play: () => import('./IconPlay'),
  table: () => import('./IconTable'),
  grid: () => import('./IconGrid'),
  control: () => import('./IconControl'),
  collection: () => import('./IconCollection'),
  save: () => import('./IconSave'),
  export: () => import('./IconExport'),
  triangleDown: () => import('./IconTriangleDown'),
  sortAlpha: () => import('./IconSortAlpha'),
  sortNum: () => import('./IconSortNum'),
  arrowDown: () => import('./IconArrowDown'),
  arrowUp: () => import('./IconArrowUp'),
  trash: () => import('./IconTrash'),
  edit: () => import('./IconEdit')
}

export default {
  props: {
    name: {
      type: String,
      default: 'box'
    },
    width: {
      type: [Number, String],
      default: '12px'
    },
    height: {
      type: [Number, String],
      default: '12px'
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    iconComponent () {
      return icons[this.name]
    }
  }
}
</script>

<style lang="scss" scoped>
.nebIcon {
  box-sizing: border-box;
  display: flex;
  align-items: center;
}
</style>
